export const addShouldNotForwardProps =
  (...shouldNotForwardProps: string[]) =>
  (prop: string): boolean =>
    !shouldNotForwardProps.includes(prop);
